import { Helmet } from "react-helmet";
import { branding } from "../resources";

type SEOProps = {
    title?: string;
    description?: string;
}

export const SEO = ({ title, description }: SEOProps) => {

    const defaultTitle = "RTK FIX Cloud";
    const defaultDescription = "A GNSS correction platform that provides highly accurate Real-time RTK and RINEX post-processing data on demand.";

    const pageTitle = title
        ? (
            branding.brandName
                ? `${branding.brandName}${branding.brandName2nd ? ' ' + branding.brandName2nd : ''} | ${title}`
                : title
        )
        : (branding.brandName
            ? `${branding.brandName}${branding.brandName2nd ? ' ' + branding.brandName2nd : ''}`
            : defaultTitle);

    const pageDescription = description
        ? description
        : (branding.brandName
            ? `${branding.brandName}${branding.brandName2nd ? ' ' + branding.brandName2nd : ''} is a GNSS correction platform that provides highly accurate Real-time RTK and RINEX post-processing data on demand.`
            : defaultDescription);

    return (
        <>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
            </Helmet>
        </>
    );
}
